import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Car = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.048}
      d="M16.879 17.991H19.3m-2.422 0v2.106S16.78 21 18.04 21s1.26-.903 1.26-.903v-2.106m-2.422 0H7.052m11.695-7.973c.506 0 .942.122 1.315.326 1.263.688 1.813 2.3 1.938 3.21v3.61c0 .722-.508.852-.761.827H19.3m-.554-7.973H5.322m.47-1.73.775-2.859C6.752 4.953 7.467 4 8.851 4h5.875c1.59 0 2.222.647 2.499 1.43a383 383 0 0 1 1.522 4.588m-13.425 0 .47-1.73m-.47 1.73a4.6 4.6 0 0 0-1.523.552m14.382-2.282h.912c.323.016.97.25.97 1.053v1.003M5.79 8.288H4.63c-.346 0-.83.511-.83 1.053v1.229m0 0c-.925.532-1.8 1.47-1.8 2.983v3.61c.046.276.318.828 1.038.828H4.63m0 0v2.106S4.53 21 5.79 21s1.26-.903 1.26-.903v-2.106m-2.421 0h2.422m6.989-3.384H9.889m9.55-1.054c0 .665-.495 1.204-1.107 1.204-.611 0-1.107-.54-1.107-1.204 0-.665.496-1.203 1.107-1.203.612 0 1.107.538 1.107 1.203m-12.872 0c0 .665-.495 1.204-1.107 1.204-.611 0-1.107-.54-1.107-1.204 0-.665.496-1.203 1.107-1.203.612 0 1.107.538 1.107 1.203"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Car) as SvgIcon;
export { ForwardRef as ReactComponent };
